import React from 'react';
import { useStoreState } from 'easy-peasy';
import { utilityGetPageState } from '@utils/get-page-state';
import { PageStateProvider } from '@components/Providers/PageStateProvider';
import {
  InterviewingHeader,
  InterviewingHorsejogs,
  InterviewingSidebar,
} from '@components/Interviewing/index';
import { Referents } from '@components/Referents/index';
import classNames from 'classnames';
import {
  jobProgressSelector,
  selectorJobIsReverseMarketing,
} from '@model/Job/Job.selectors';
import {
  JOB_PAGE_STATES,
  JOB_PROGRESS_STATES,
} from '@model/Job/_constants/Job.constants';
import { candidatesSelector } from '@model/Candidate/Candidate.selectors';

const Interviewing = () => {
  const progress = useStoreState(jobProgressSelector);
  const { results: candidates } = useStoreState(candidatesSelector);
  const isJobReverseMarketing = useStoreState(selectorJobIsReverseMarketing);

  const pageState = utilityGetPageState({
    progress,
    currentRoute: JOB_PROGRESS_STATES.INTERVIEWING,
    hasApplications: candidates.length > 0,
  });

  const isPageStateDoing = pageState === JOB_PAGE_STATES.DOING;
  const isPageStateDone = pageState === JOB_PAGE_STATES.DONE;

  const pageBodyClassNames = classNames(
    'rev-o-container rev-o-container--full',
    {
      'rev-u-mt-80': isPageStateDoing,
    },
  );

  const horsejogsWrapperClassNames = classNames('rev-o-col-12 rev-u-mb-24', {
    'rev-u-mt-32': isPageStateDone,
  });

  const isReferentsSectionVisible = isJobReverseMarketing
    ? isPageStateDoing || isPageStateDone
    : isPageStateDoing;

  return (
    <PageStateProvider value={pageState}>
      <section data-testid="interviewing-page">
        <div className="rev-o-container">
          <div className="rev-o-grid">
            <InterviewingHeader />
            <InterviewingSidebar />
          </div>
        </div>

        {pageState !== JOB_PAGE_STATES.TO_DO ? (
          <div className={pageBodyClassNames}>
            <div className="rev-o-grid">
              <div className={horsejogsWrapperClassNames}>
                <InterviewingHorsejogs />
              </div>
            </div>
          </div>
        ) : null}

        {isReferentsSectionVisible ? (
          <div className="rev-o-container">
            <div className="rev-o-grid">
              <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-6">
                <Referents />
              </div>
            </div>
          </div>
        ) : null}
      </section>
    </PageStateProvider>
  );
};

export default Interviewing;
